export default "__VITE_ASSET__BmgTy4N$__"